import { Dimensions, Platform } from "react-native";

export const isPlatformAndroid = Platform.OS === "android";
export const isPlatformWeb = Platform.OS === "web";

export const { width: deviceWidth, height: deviceHeight } =
  Dimensions.get("window");
